import styled from '@emotion/styled'

const handleDisplayPolicyStatusColor = ({
  status,
}: {
  status: 'UPLOADED' | 'PENDING' | 'CANCELLED'
}) => {
  const colorSet = {
    UPLOADED: {
      background: '#009640',
    },
    PENDING: {
      background: '#276EF1',
    },
    CANCELLED: {
      background: '#666666',
    },
  }
  return colorSet[status]?.background || '#000'
}

export const Dot = styled('div')<{ status: 'UPLOADED' | 'PENDING' | 'CANCELLED' }>`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: ${(props) => handleDisplayPolicyStatusColor({ status: props.status })};
`

export const ButtonIcon = styled('img')`
  cursor: pointer;
  width: 20px;
  height: 20px;
`
